import {call, select, put, takeLatest, take, fork, race} from 'redux-saga/effects'
import {actionTypes, selectors} from './location'
import {gtmEvent} from './gtm'
import {postcodeActionTypes} from '../gtm-events'
import {
  getCurrentPosition,
  fetchGeoDataFromPosition,
  fetchGeoDataFromPostcode,
} from '../../apis/geo'
import {persist} from '../../apis/persist'

const {
  LOCATION_FETCH_START,
  LOCATION_FETCH_SUCCESS,
  LOCATION_FETCH_ERROR,
  LOCATION_FETCH_REQUEST,
  UPDATE_POSTCODE_REQUEST,
  UPDATE_POSTCODE_SUCCESS,
  POSTCODE_INPUT_REQUEST,
  POSTCODE_INPUT_CANCEL,
  POSTCODE_POPUP_SHOW,
  POSTCODE_POPUP_HIDE,
  LOCATION_CONFIRMED,
} = actionTypes

function* updatePostcode({payload}) {
  yield put({type: LOCATION_FETCH_START})
  
  try {
    const {
      state,
      locality,
      postcode: newPostcode,
    } = yield call(fetchGeoDataFromPostcode, payload.postcode)
    
    persist({
      postcode: newPostcode,
      state,
      locality,
      localDealer: '',
    })
    
    yield put({type: UPDATE_POSTCODE_SUCCESS})
    yield put(gtmEvent({
      gtmID: postcodeActionTypes.PCPU_ENTER_POSTCODE,
      gtmPayload: {postcode: newPostcode},
    }))
    yield put({
      type: LOCATION_FETCH_SUCCESS,
      payload: {
        state,
        locality,
        postcode: newPostcode,
      },
    })
  } catch (error) {
    console.warn(error)
    yield put({type: LOCATION_FETCH_ERROR, payload: {error}})
  }
}

function* fetchLocation() {
  let {latitude, longitude} = yield select(selectors.getLocation)
  
  try {
    // 'NaN' as a string will come out as truthy, so we cast for this check
    if (!(Number(latitude) && Number(longitude))) {
      const {coords} = yield getCurrentPosition()
      latitude = coords.latitude
      longitude = coords.longitude
    }
    
    persist({latitude, longitude})
    
    yield put({type: LOCATION_FETCH_START})
    
    const {
      postcode,
      locality,
      state,
    } = yield call(fetchGeoDataFromPosition, {
      latitude,
      longitude,
    })
    persist({
      postcode,
      state,
      locality,
      localDealer: '',
    })
    
    const {locationConfirmed} = yield select(selectors.getLocation)
    
    yield put({
      type: LOCATION_FETCH_SUCCESS,
      payload: {
        state,
        locality,
        postcode,
      },
    })
    if (!locationConfirmed) yield call(requestPostcodeInput)
  } catch (error) {
    console.warn(error)
    const {state, locationConfirmed} = yield select(selectors.getLocation)
    
    yield put({type: LOCATION_FETCH_ERROR, payload: {error}})
    if (!state && !locationConfirmed) yield call(requestPostcodeInput)
  }
}

function* requestPostcodeInput() {
  const {postcodePopupOpen} = yield select(selectors.getLocation)
  
  if (!postcodePopupOpen) {
    yield put({type: POSTCODE_POPUP_SHOW})
    
    const {gotPostcode, closed} = yield race({
      gotPostcode: take(UPDATE_POSTCODE_SUCCESS),
      closed: take(POSTCODE_POPUP_HIDE),
    })
    
    if (gotPostcode || closed) {
      persist({locationConfirmed: true})
      yield put({type: LOCATION_CONFIRMED})
      if (!closed) yield put({type: POSTCODE_POPUP_HIDE})
    }
  }
}

function* cancelPostcodeInput() {
  yield put({type: POSTCODE_POPUP_HIDE})
}

export default function* () {
  yield [
    fork(function* () {
      yield takeLatest(LOCATION_FETCH_REQUEST, fetchLocation)
    }),
    fork(function* () {
      yield takeLatest(UPDATE_POSTCODE_REQUEST, updatePostcode)
    }),
    fork(function* () {
      yield takeLatest(POSTCODE_INPUT_REQUEST, requestPostcodeInput)
    }),
    fork(function* () {
      yield takeLatest(POSTCODE_INPUT_CANCEL, cancelPostcodeInput)
    }),
  ]
}



// WEBPACK FOOTER //
// ./src/store/actions/location-async.js